import type { StyleProp, TextStyle } from "react-native";
import { Text } from "react-native-paper";

// Renders a string containing inline <b>...</b> markup (as authored in the
// source HTML copy) with bold runs. No other markup is supported.

type Props = { text: string; style?: StyleProp<TextStyle>; boldColor?: string };

export function BoldText({ text, style, boldColor }: Props) {
    const parts = text.split(/(<b>.*?<\/b>)/g).filter((p) => p.length > 0);
    return (
        <Text style={style}>
            {parts.map((p, i) => {
                const m = p.match(/^<b>(.*)<\/b>$/);
                if (m) {
                    return (
                        <Text
                            key={i}
                            style={[{ fontWeight: "800" }, boldColor ? { color: boldColor } : null]}
                        >
                            {m[1]}
                        </Text>
                    );
                }
                return <Text key={i}>{p}</Text>;
            })}
        </Text>
    );
}
